import { useContext, useEffect, useState } from 'react';
import GenericActionModal from '../../../../components/genericActionModal';
import { IonButton, IonRippleEffect } from '@ionic/react';
import classNames from 'classnames';
import { DeviceContext } from '../../../../deviceType';
import { CartItem, ProductType } from '../../../../types/product';
import { IoMdAdd } from 'react-icons/io';
import { FaMinus } from 'react-icons/fa6';
import {
  addToCart,
  getAllCartItems,
  updateCartItem,
} from '../../../../context/actions/cart';
import useGlobalContext from '../../../../hooks/useStore';
import { UPDATE_CART_ITEM_ERROR } from '../../../../context/actions/types';
import ErrorToast from '../../../../components/error_toast';
import Spinner from '../../../../components/spinner';

const AddToCartModal = ({
  trigger,
  product,
}: {
  trigger: string;
  product: ProductType;
}) => {
  const size = useContext(DeviceContext);
  const [open, setOpen] = useState<boolean>(false);
  const [isInCart, setIsInCart] = useState<boolean>(false);
  const [count, setCount] = useState(0);
  const [cartItem, setCartItem] = useState<CartItem>();
  const [loading, setLoading] = useState<boolean>(false);
  const [openError, setOpenError] = useState<boolean>(false);
  const [error, setError] = useState<string>('');
  const { cartDispatch, cartState } = useGlobalContext();
  useEffect(() => {
    if (cartState.updateCartError) {
      setError(cartState.updateCartError.message);
      setOpenError(true);
      cartDispatch({ type: UPDATE_CART_ITEM_ERROR, payload: null });
    }
    if (cartState.cart) {
      setLoading(false);
      let state = cartState.cart!.find((e) => e.product.id === product.id);
      if (state) {
        setCount(state.count);
        setCartItem(state);
        setIsInCart(true);
      }
    }
  }, [cartState]);

  const changeCount = (add: boolean = false, minus: boolean = false) => {
    let _count = count;
    if (add) {
      _count += 1;
      setCount(_count);
    }
    if (minus) {
      if (_count === 1) {
        return;
      }
      _count -= 1;
      setCount(_count);
    }

    if (isInCart) {
      updateCount(_count);
    }
  };
  const updateCount = async (count: number) => {
    setLoading(true);
    const res = await updateCartItem({ count, cartItemId: cartItem!.id });
    if (res.error) {
      setError(res.error);
      setOpenError(true);
    }
    await getAllCartItems()(cartDispatch);
  };
  const add = async () => {
    let cartItem = {
      count,
      product,
    };
    close();
    await addToCart(cartItem)(cartDispatch);
  };

  const close = () => {
    setOpen(false);
    !cartItem?.id ? setCount(0) : setCount(cartItem?.count);
  };
  return (
    <GenericActionModal
      trigger={trigger}
      open={open}
      position="bottom"
      width={classNames({
        '25dvw': size.width >= 768,
        '100dvw': size.width < 768,
      })}
      onPresent={() => {
        setOpen(true);
      }}
      onDismiss={() => {
        close();
      }}
    >
      <ErrorToast
        isOpen={openError}
        message={error}
        onClose={() => {
          setOpenError(false);
        }}
        type="error"
        position="bottom"
      />
      <div className=" w-full h-fit flex flex-col items-center justify-center px-2 pb-6 pt-4 overflow-hidden">
        <div className="w-full h-fit py-4">
          <div className="w-full h-auto flex items-center justify-between px-2">
            <p className="text-primary font-normal font-roboto text-lg">
              Quantity
            </p>
            <div className="w-auto h-8 flex items-center justify-center">
              <div
                className="relative overflow-hidden w-auto h-full aspect-square flex items-center justify-center py-[6px] mr-4 ion-activatable ripple-parent circle cursor-pointer rounded-lg"
                onClick={() => changeCount(false, true)}
              >
                <IonRippleEffect />
                <FaMinus className="w-auto h-full aspect-square" size="100%" />
              </div>
              <div className="w-10 h-full border-2 rounded-xl border-primary flex items-center justify-center text-primary font-normal font-roboto text-sm md:text-lg">
                {loading ? (
                  <div className="h-4 md:h-6 w-auto flex items-center justify-center text-primary py-[4px] md:py-[3px] px-[2px]">
                    <Spinner type="lines-small" />
                  </div>
                ) : (
                  count
                )}
              </div>
              <div
                className="relative overflow-hidden w-auto h-full aspect-square flex items-center justify-center py-[6px] ml-4 ion-activatable ripple-parent circle cursor-pointer rounded-lg"
                onClick={() => changeCount(true, false)}
              >
                <IonRippleEffect />
                <IoMdAdd className="w-auto h-full aspect-square" size="100%" />
              </div>
            </div>
          </div>
        </div>
        {!isInCart ? (
          <div className="w-full h-fit flex justify-end items-center mt-4">
            <IonButton
              color="primary"
              fill="solid"
              expand="block"
              className=" w-full "
              onClick={add}
              disabled={loading || !count || count === cartItem?.count}
            >
              <span className="px-2">Add To Cart</span>
              {loading && (
                <div className="h-full w-auto aspect-square flex items-center">
                  <Spinner type="crescent" />
                </div>
              )}
            </IonButton>
          </div>
        ) : (
          ''
        )}
      </div>
    </GenericActionModal>
  );
};

export default AddToCartModal;
